import React, { useCallback, useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { InputAdornment, IconButton, Modal, Grid } from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";

import StyledButton from "../../components/CustomButtons/StyledButton";
import CustomInput from "../../components/CustomInput/CustomInput";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    position: "relative",
    borderRadius: 8,
    boxShadow: theme.shadows[5],

    outline: "none",
    minWidth: "auto",
    maxWidth: 477,
    textAlign: "center",
  },
  container: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  closeButtonIcon: {
    color: "black",
  },
  title: {
    marginBottom: 10,
    fontSize: 24,
    fontWeight: 400,
  },
  buttonsContainer: {
    marginTop: 10,
  },
  inputLabelContainer: {
    textTransform: "capitalize",
  },
  inputLabel: {
    color: "red",
    paddingRight: "5px",
  },
}));

const PasswordConfirmation = ({
  title,
  subtitle,
  isOpen,
  onClose,
  onSubmit,
  password,
}) => {
  const classes = useStyles();

  // const [state, setState] = useState(null);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isPasswordValid, setPasswordValid] = useState(false);

  const [passwordError, setPasswordError] = useState(null);

  const onChangePasswordVisibility = useCallback(
    () => setPasswordVisible((prevState) => !prevState),
    [setPasswordVisible]
  );

  useEffect(() => {
    if (passwordError !== null) {
      setPasswordValid(passwordError === "");
    }
  }, [passwordError, setPasswordValid]);

  const onChangePassword = useCallback(
    (event) => {
      const _password = event.target.value;

      if (_password && _password.trim() !== "") {
        if (_password !== password) {
          setPasswordError(" La clave ingresada no es válida");
        } else {
          setPasswordError("");
        }
      } else {
        setPasswordError("La clave es requerida");
      }
    },
    [password, setPasswordError]
  );

  const onSend = useCallback(() => {
    onClose();
    onSubmit();
  }, [onClose, onSubmit]);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className={classes.root}
      disableBackdropClick={true}
    >
      <div className={classes.paper}>
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon className={classes.closeButtonIcon} />
        </IconButton>

        <Grid
          container
          spacing={0}
          justify="center"
          className={classes.container}
        >
          <Grid item xs={12}>
            <Typography className={classes.title}>{title}</Typography>
          </Grid>

          {subtitle && (
            <Grid item xs={12}>
              <Typography>{subtitle}</Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            <CustomInput
              success={!passwordError}
              error={!!passwordError}
              errMsg={passwordError}
              labelText={
                <span className={classes.inputLabelContainer}>
                  <span className={classes.inputLabel}>*</span>
                  <span>Clave</span>
                </span>
              }
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                type: isPasswordVisible ? "text" : "password",
                onChange: onChangePassword,
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={onChangePasswordVisibility}
                    >
                      {isPasswordVisible ? (
                        <VisibilityOutlinedIcon />
                      ) : (
                        <VisibilityOffOutlinedIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} className={classes.buttonsContainer}>
            <StyledButton disabled={!isPasswordValid} onClick={onSend}>
              ENVIAR
            </StyledButton>
          </Grid>

          {/*<Grid item xs={12}>*/}
          {/*  {JSON.stringify({ passwordError, isPasswordValid })}*/}
          {/*</Grid>*/}
        </Grid>
      </div>
    </Modal>
  );
};

export default PasswordConfirmation;
